import { useState } from "react";
import { useIonLoading, useIonToast } from "@ionic/react";
import {
    getStatements,
    postAcceptStatement,
} from "../services/StatementServices";
import { useAuth } from "../context/Auth";
import { useAppDispatch } from "../store/hooks";
import { setStatements } from "../store/slices/statementSlice";
// import { StatementModel } from "../models/GlobalModels";

export const useStatements = () => {
    const dispatch = useAppDispatch();
    const [presentLoading, dismissLoading] = useIonLoading();
    const [presentToast] = useIonToast();
    // const [fetchStatementsLoading, setFetchStatementsLoading] =
    //     useState<boolean>(false);
    const [acceptStatementLoading, setAcceptStatementLoading] =
        useState<boolean>(false);
    // const [statements, setStatements] = useState<StatementModel[]>([]);
    const { checkAxiosError } = useAuth();

    const fetchStatements = async () => {
        // setFetchStatementsLoading(true);
        await presentLoading("Nyilatkozatok lekérdezése...");
        getStatements()
            .then((res: any) => {
                dispatch(setStatements(res.data ?? []));
            })
            .catch((err: any) => {
                checkAxiosError(err);
                presentToast(
                    "Hiba történt a nyilatkozatok lekérdezése közben."
                );
            })
            .finally(() => dismissLoading().catch(() => {}));
        // .finally(() => setFetchStatementsLoading(false));
    };
    const acceptStatement = async (acceptable_statement_id: number) => {
        await presentLoading("Nyilatkozat elfogadása...");
        setAcceptStatementLoading(true);
        postAcceptStatement(acceptable_statement_id)
            .then((res: any) => {
                const tempStatements = res.data?.availableStatements ?? [];
                if (
                    tempStatements.length === 0 &&
                    window.location.pathname !== "/my/dashboard"
                ) {
                    window.location.href = "/my/dashboard";
                }
                dispatch(setStatements(tempStatements));
            })
            .catch((err: any) => {
                checkAxiosError(err);
                presentToast("Hiba történt a nyilatkozat elfogadása közben.");
            })
            .finally(() => {
                dismissLoading().catch(() => {});
                setAcceptStatementLoading(false);
            });
    };

    return {
        // statements,
        // fetchStatementsLoading,
        acceptStatementLoading,
        fetchStatements,
        acceptStatement,
    };
};
